export default (state = {}, action) => {
  switch (action.type) {
    case 'GET_FAMILY':
      return { ...state, family: action.family };
    case 'GET_FAMILIES':
      return { ...state, families: action.families };
    case 'GET_CATEGORIES_FAM':
      return { ...state, categories: action.categories };
    case 'GET_CATEG_FAMILIES':
      return { ...state, categoryfamilies: action.categoryfamilies };
    default:
      return state;
  }
};
